import { type FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { FormattedMessage } from 'dibs-react-intl';
import { SeoLink } from 'dibs-seo/exports/SeoLink.tsx';
import { NO_CONTENT_LINK } from 'dibs-elements/exports/SeoLink.tsx';

import { type DesignSeriesHeroByline_iconicDesignSeriesPage$data } from './__generated__/DesignSeriesHeroByline_iconicDesignSeriesPage.graphql.ts';

import styles from './DesignSeriesHeroByline.scss';

type Props = {
    iconicDesignSeriesPage: DesignSeriesHeroByline_iconicDesignSeriesPage$data;
};

const DesignSeriesHeroBylineComponent: FC<Props> = props => {
    const { iconicDesignSeriesPage } = props;
    const { creatorLinks } = iconicDesignSeriesPage;
    if (!creatorLinks || !creatorLinks.length) {
        return null;
    }

    return (
        <div className={styles.byline}>
            {creatorLinks.map((creatorLink, idx) => {
                if (!creatorLink) {
                    return null;
                }
                const { linkData, displayName } = creatorLink;
                if (!linkData || !displayName) {
                    return null;
                }
                return (
                    <div key={displayName}>
                        {idx === 0 ? (
                            <FormattedMessage
                                defaultMessage="By "
                                id="designSeries.DesignSeriesHeroByline.byline"
                            />
                        ) : null}
                        <SeoLink
                            dataTn={`design-series-byline-link-${displayName}`}
                            linkData={linkData}
                            key={displayName}
                            variant={NO_CONTENT_LINK}
                        >
                            {creatorLink.displayName}
                        </SeoLink>
                        {idx < creatorLinks.length - 1 ? ',' : null}
                    </div>
                );
            })}
        </div>
    );
};

export const DesignSeriesHeroByline = createFragmentContainer(DesignSeriesHeroBylineComponent, {
    iconicDesignSeriesPage: graphql`
        fragment DesignSeriesHeroByline_iconicDesignSeriesPage on IconicDesignSeriesPage {
            creatorLinks {
                displayName
                linkData {
                    ...SeoLink_linkData
                }
            }
        }
    `,
});
